module.exports = __webpack_public_path__ + "static/media/logo.418e8073.png";